import classNames from 'classnames';

import Button from '~components/Button/Button';
import Chevron from '~images/inline/triangle-right.inline.svg';

const MobileTab = ({
    children,
    ctalink,
    isActive,
    question,
    handleTabClick,
}: React.PropsWithChildren<{
    ctalink: string;
    isActive: boolean;
    question: string;
    title: string;
    handleTabClick: () => void;
}>) => {
    return (
        <article
            className={classNames(
                'w-full flex flex-col',
                'shadow-md rounded-lg bg-white p-6 gap-6'
            )}
        >
            <button onClick={handleTabClick}>
                <h3
                    className={classNames(
                        'text-18 md:text-20',
                        'font-bold font-poppins text-primary-dark text-left',
                        'w-full flex justify-between'
                    )}
                >
                    {question}
                    <Chevron className={classNames('w-6 h-6', isActive && 'rotate-90')} />
                </h3>
            </button>
            <div className={classNames(!isActive && 'hidden')}>
                {children}
                <Button islink={true} to={ctalink} styletype="primary" className="w-full">
                    Learn more
                </Button>
            </div>
        </article>
    );
};

export default MobileTab;
